import { useGraphql } from 'utils/hooks/useGraphql';

import { DEFAULT_TEMPLATES, USE_TEMPLATES_HOOK_QUERY } from './constants';
import { UseTemplatesHookInputs, UseTemplatesHookOutput, UseTemplatesQueryData } from './types';
import { useTemplatesVariables } from './useTemplatesVariables';

export const useTemplates = ({ search }: UseTemplatesHookInputs): UseTemplatesHookOutput => {
  const variables = useTemplatesVariables(search);
  const {
    data: { templates: data } = {},
    error: didError,
    isLoading,
  } = useGraphql<UseTemplatesQueryData>(USE_TEMPLATES_HOOK_QUERY, { variables });
  return { templates: data?.results ?? DEFAULT_TEMPLATES, didError, isLoading };
};
